





























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class UiProgressRingComponent extends Vue {
  @Prop({
    default: 'default'
  })
  public schema: string;

  @Prop({
    default: 'dashboard'
  })
  public type: string;

  @Prop({
    default: 200
  })
  public ringSize: number;

  @Prop({
    default: 124
  })
  public circleSize: number;

  @Prop({
    default: 96
  })
  public circleRadius: number;

  @Prop({
    default: 6
  })
  public strokeWidth: number;

  @Prop()
  public centerTitle: string;

  @Prop()
  public centerText: string;

  @Prop()
  public label: string;

  @Prop()
  public description: string;

  @Prop({
    default: 0
  })
  public fillValue: number;

  @Prop({
    default: ''
  })
  public circleColor: string;

  @Prop({
    default: ''
  })
  public outerColor: string;

  @Prop({
    default: false
  })
  public isPractice: boolean;

  @Prop({
    default: 0
  })
  public currentValue: number;

  private circumference() {
    return this.circleRadius * 2 * Math.PI;
  }

  private dashOffset() {
    const c = this.circumference();
    return c - (this.fillValue / 100) * c;
  }

  private dashOffsetHalf() {
    const c = this.circumference();
    return c - 0.5 * c;
  }

  private dashOffsetBase() {
    const c = this.circumference();
    if (this.fillValue < 0) {
      return c - ((this.currentValue) / 200) * c;
    }
    return c - ((this.currentValue - this.fillValue) / 200) * c;
  }

  private dashOffsetDifference() {
    const c = this.circumference();
    if (this.fillValue < 0) {
      return c - ((this.currentValue - this.fillValue) / 200) * c;
    }
    return c - (this.currentValue / 200) * c;
  }

  private dashArray() {
    const c = this.circumference();
    return `${c} ${c}`;
  }

  private progressColor() {
    return this.fillValue < 0 ? 'red' : 'green';
  }
}
